document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cta-ribbon').forEach(section => {
    const band = section.querySelector('.cta-ribbon__band');
    const btn = section.querySelector('.cta-ribbon__cta a');
    if (!band) return;

    // If there is a button, no need to make the whole band clickable.
    if (btn && btn.getAttribute('href')) return;

    // If no button present, but heading has a link in the editor (rare),
    // you can adapt this to read a data attribute. For now, do nothing.
  });
});
